module.exports = __webpack_public_path__ + "static/Bg10a-b414881a196a56cda16a9c3d2d16776e.png";